import React, { Component } from "react";
import GetUserToken from "./getToken";
import axios from "axios";
import { baseUrl } from "../assets/baseUrl";

export default class TelegramLink extends Component {
  state = {
    level: {},
    teacherInfo: {}
  };

  componentDidMount() {
    const token = GetUserToken();
    if (token != null) {
      axios
        .get(`${baseUrl}api/Students/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.setState({
            level: res.data.level,
          });
        });
    }

    axios.get(`${baseUrl}api/Setting`).then((res) => {
      this.setState({
        teacherInfo: res.data,
      });
      // console.log(teacherInfo);
    });
  }

  render() {
    const { level, teacherInfo } = this.state;
    const token = GetUserToken();
    // if (!token) {
    //   return null;
    // }

    return (
      <div className="telegramLink">
        <a href={teacherInfo.whatsappLink} target="_blank">
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    );
  }
}
